import { BackendModel } from "shared/libraries/backend/BackendModel";
import { ProjectModel } from "shared/libraries/backend/Project";
import { VirtualTourModel } from "shared/libraries/backend/VirtualTour";
import { StillModel } from "shared/libraries/backend/Still";
import { VideoModel } from "./Video";
import { LightingModel } from "./Lighting";

export enum TNotificationType {
    NotificationTypeSystemStart = 1,
    NotificationTypeProjectLoaded = 10,
    NotificationTypeNormaJsonPlusStarted = 101,
    NotificationTypeNormaJsonPlusSceneGenerated = 102,
    NotificationTypeNormaJsonSerialized = 103,
    NotificationTypeNormaJsonUploaded = 104
}

export type TNotification = {
    id?: number,
    project?: number,
    virtual_tour?: number,
    still?: number,
    video?: number,
    lighting?: number,
    type: TNotificationType,
    created_at?: string
}

export class NotificationModel extends BackendModel {
    static path: string = `${BackendModel.base}/n/`;
    readonly data: TNotification;

    constructor(data: TNotification) {
        super();
        this.data = data;
    }

    private static async create(notification) : Promise<NotificationModel> {
        const response : TNotification = await super.post<TNotification, TNotification>(NotificationModel.path, notification);
        const instance : NotificationModel = new NotificationModel(response);
        return instance;
    }
    static async fromSystem(type: TNotificationType) : Promise<NotificationModel> {
        const notification : TNotification = {
            type: type
        };
        return await this.create(notification);
    }
    static async fromProject(project: ProjectModel, type: TNotificationType) : Promise<NotificationModel> {
        const notification : TNotification = {
            project: project.data.id,
            type: type
        };
        return await this.create(notification);
    }
    static async fromVirtualTour(model: VirtualTourModel, type: TNotificationType) : Promise<NotificationModel> {
        const notification : TNotification = {
            project: model.data.project,
            virtual_tour: model.data.id,
            type: type
        };
        return await this.create(notification);
    }

    static async fromStill(model: StillModel, type: TNotificationType) : Promise<NotificationModel> {
        const notification : TNotification = {
            project: model.data.project,
            still: model.data.id,
            type: type
        };
        return await this.create(notification);
    }

    static async fromVideo(model: VideoModel, type: TNotificationType) : Promise<NotificationModel> {
        const notification : TNotification = {
            project: model.data.project,
            still: model.data.id,
            type: type
        };
        return await this.create(notification);
    }

    static async fromLighting(model: LightingModel, type: TNotificationType) : Promise<NotificationModel> {
        const notification : TNotification = {
            project: model.data.project,
            lighting: model.data.id,
            type: type
        };
        return await this.create(notification);
    }
}

export type TNotificationCallback = (instance: NotificationModel) => any;